import forDevice from '../../hoc/for-device';
import ActionsMenuMobile from './actions-menu-mobile';
import ActionsMenuDesktop from './actions-menu-desktop';
export const ActionsMenu = forDevice(ActionsMenuMobile, ActionsMenuDesktop, {
    forceDesktopWhenInlineMobile: true,
});
//# sourceMappingURL=index.js.map